// extracted by mini-css-extract-plugin
export default {"header":"Header_header__4YPBy","header__left":"Header_header__left__1ioW8","header__right":"Header_header__right__1LnhS"};